import { render, staticRenderFns } from "./addorder.vue?vue&type=template&id=ec7003f6&scoped=true&"
import script from "./addorder.vue?vue&type=script&lang=js&"
export * from "./addorder.vue?vue&type=script&lang=js&"
import style0 from "./addorder.vue?vue&type=style&index=0&lang=css&"
import style1 from "./addorder.vue?vue&type=style&index=1&id=ec7003f6&leng=less&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec7003f6",
  null
  
)

export default component.exports